import { gql } from '@apollo/client';

export const CREATE_PATIENT = gql`
  mutation CreatePatient($record: CreatePatientInput!) {
    user {
      patientUser {
        createPatient(record: $record) {
          ok
          error {
            message
            code
          }
          resultId
          result {
            id
            ins
            name {
              firstName
              lastName
            }
            email
            phone
            gender
            birthDate
            birthPlace {
              country
              city
              address
              zipcode
            }
            preferredLanguages
          }
        }
      }
    }
  }
`;
